var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-6 mt-3" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("Login.WebService.Title")))]),
        _vm._v(" "),
        _c("section", { attrs: { "aria-label": _vm.$t("Login.Login") } }, [
          _c(
            "form",
            {
              attrs: { id: "loginForm" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.loginDebounced($event)
                }
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("span", { staticClass: "col-12 col-sm-3 col-form-label" }, [
                  _c(
                    "label",
                    { staticClass: "mb-0 mb-sm-2", attrs: { for: "email" } },
                    [_vm._v(_vm._s(_vm.$t("Login.Email")))]
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "col-12 col-sm-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.email,
                        expression: "user.email"
                      }
                    ],
                    staticClass: "col form-control",
                    attrs: {
                      type: "text",
                      id: "email",
                      placeholder: _vm.$t("Login.Email")
                    },
                    domProps: { value: _vm.user.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "email", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-2 mb-sm-0" }, [
                _c("span", { staticClass: "col-12 col-sm-3 col-form-label" }, [
                  _c(
                    "label",
                    { staticClass: "mb-0 mb-sm-2", attrs: { for: "password" } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("Login.Password")) +
                          "\n              "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "col-12 col-sm-9" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.password,
                        expression: "user.password"
                      }
                    ],
                    staticClass: "col form-control",
                    attrs: {
                      type: "password",
                      id: "password",
                      placeholder: _vm.$t("Login.Password")
                    },
                    domProps: { value: _vm.user.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "password", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "span",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary login-page-button",
                        attrs: { type: "submit" }
                      },
                      [_vm._v(_vm._s(_vm.$t("Login.Login")))]
                    ),
                    _vm._v(" "),
                    _c("bounce-loader", {
                      staticClass: "loader",
                      attrs: {
                        loading: _vm.showLoader,
                        color: _vm.color,
                        size: _vm.size
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "sr-only",
                        attrs: { "aria-live": "assertive" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.showLoader ? _vm.$t("Login.LoggingIn") : ""
                          )
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "col-12 col-sm-6 right-sm" }, [
                  _c(
                    "a",
                    {
                      staticClass: "d-inline-block col-form-label",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.forgotPassword($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Login.PasswordForgotten")))]
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-md-6 mb-2 mb-md-0 mt-3 mt-md-4" }, [
        _c("h2", { staticClass: "login-page-h2" }, [
          _vm._v(_vm._s(_vm.$t("Login.NewOrganisation.Title")))
        ]),
        _vm._v(" "),
        _c("div", {
          domProps: {
            innerHTML: _vm._s(_vm.$t("Login.NewOrganisation.Description"))
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary login-page-button",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.registerOrganisation()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("Login.NewOrganisation.Button")))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 mb-2 mb-md-0 mt-3 mt-md-4" }, [
        _c("h2", { staticClass: "login-page-h2" }, [
          _vm._v(_vm._s(_vm.$t("Login.NewUser.Title")))
        ]),
        _vm._v(" "),
        _c("div", {
          domProps: { innerHTML: _vm._s(_vm.$t("Login.NewUser.Description")) }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-secondary login-page-button",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "register" })
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("Login.NewUser.Button")))]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-12 mb-2 mb-md-0 mt-3 mt-md-4" }, [
        _c("div", {
          staticClass: "stea-info",
          domProps: { innerHTML: _vm._s(_vm.$t("Login.SteaInfo.Description")) }
        }),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-secondary login-page-button mb-5",
            attrs: {
              type: "button",
              href: "https://www.stea.fi/avustusten-hakeminen/verkkoasiointi/",
              target: "_blank"
            }
          },
          [_vm._v(_vm._s(_vm.$t("Login.SteaInfo.Button")))]
        )
      ]),
      _vm._v(" "),
      _vm._m(1)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-lg-6 d-none d-md-block pt-3 pb-3" },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: require("../../../common/design/images/verkkoasiointi_etusivu.jpg"),
            alt: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 d-block d-md-none my-3 mobile-image" },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: require("../../../common/design/images/verkkoasiointi_etusivu.jpg"),
            alt: ""
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }